module.exports = __webpack_public_path__ + "img/logo.8ac8206c.png";